__turbopack_context__.v({
  "chart": "ECGChart-module__yQireG__chart",
  "trace": "ECGChart-module__yQireG__trace",
});
